const VERDANT_MAIL = {
  slug: "verdant-mail",
  name: "Verdant Mail",
  description: "Tinted with forest moss",
  rarity: "common",
  slot: "armor",
  shopCategory: "metal-armor",
  statChanges: [
    { stat: "armor", value: 8 },
    { stat: "greenColor", value: 3 }
  ],
  sprite: {
    sheet: "wardrobe/metal/metal_green",
    frameIndex: 0
  },
  bodySprite: "characters/body/body_green",
  tags: ["daily-rotation", "metal"]
};
export {
  VERDANT_MAIL
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vLi4vbGliL2l0ZW1zL2FybW9ycy9tZXRhbC92ZXJkYW50LW1haWwudHMiXSwKICAic291cmNlc0NvbnRlbnQiOiBbImltcG9ydCB7IEl0ZW1EZWZpbml0aW9uIH0gZnJvbSAnLi4vLi4vdHlwZXMnO1xuXG5leHBvcnQgY29uc3QgVkVSREFOVF9NQUlMOiBJdGVtRGVmaW5pdGlvbiA9IHtcbiAgc2x1ZzogJ3ZlcmRhbnQtbWFpbCcsXG4gIG5hbWU6ICdWZXJkYW50IE1haWwnLFxuICBkZXNjcmlwdGlvbjogJ1RpbnRlZCB3aXRoIGZvcmVzdCBtb3NzJyxcbiAgcmFyaXR5OiAnY29tbW9uJyxcbiAgc2xvdDogJ2FybW9yJyxcbiAgc2hvcENhdGVnb3J5OiAnbWV0YWwtYXJtb3InLFxuICBzdGF0Q2hhbmdlczogW1xuICAgIHsgc3RhdDogJ2FybW9yJywgdmFsdWU6IDggfSxcbiAgICB7IHN0YXQ6ICdncmVlbkNvbG9yJywgdmFsdWU6IDMgfSxcbiAgXSxcbiAgc3ByaXRlOiB7XG4gICAgc2hlZXQ6ICd3YXJkcm9iZS9tZXRhbC9tZXRhbF9ncmVlbicsXG4gICAgZnJhbWVJbmRleDogMCxcbiAgfSxcbiAgYm9keVNwcml0ZTogJ2NoYXJhY3RlcnMvYm9keS9ib2R5X2dyZWVuJyxcbiAgdGFnczogWydkYWlseS1yb3RhdGlvbicsICdtZXRhbCddLFxufTtcbiJdLAogICJtYXBwaW5ncyI6ICJBQUVPLE1BQU0sZUFBK0I7QUFBQSxFQUMxQyxNQUFNO0FBQUEsRUFDTixNQUFNO0FBQUEsRUFDTixhQUFhO0FBQUEsRUFDYixRQUFRO0FBQUEsRUFDUixNQUFNO0FBQUEsRUFDTixjQUFjO0FBQUEsRUFDZCxhQUFhO0FBQUEsSUFDWCxFQUFFLE1BQU0sU0FBUyxPQUFPLEVBQUU7QUFBQSxJQUMxQixFQUFFLE1BQU0sY0FBYyxPQUFPLEVBQUU7QUFBQSxFQUNqQztBQUFBLEVBQ0EsUUFBUTtBQUFBLElBQ04sT0FBTztBQUFBLElBQ1AsWUFBWTtBQUFBLEVBQ2Q7QUFBQSxFQUNBLFlBQVk7QUFBQSxFQUNaLE1BQU0sQ0FBQyxrQkFBa0IsT0FBTztBQUNsQzsiLAogICJuYW1lcyI6IFtdCn0K
